import { render, staticRenderFns } from "./SmsPushConfigList.vue?vue&type=template&id=799d5620&scoped=true&"
import script from "./SmsPushConfigList.vue?vue&type=script&lang=js&"
export * from "./SmsPushConfigList.vue?vue&type=script&lang=js&"
import style0 from "./SmsPushConfigList.vue?vue&type=style&index=0&id=799d5620&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799d5620",
  null
  
)

export default component.exports